module.exports = __webpack_public_path__ + "img/step1-1.196c4a72.png";